<template>
    <div>
        <b-card class="sa-card sa-card-border mb-3" header="Linguaggio scritto (L.Scr)" header-tag="header">

            <b-card class="sa-card sa-card-border mb-3" header="Parte prima: Lettura ad alta voce" header-tag="header">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">1. Erba</label>
                                <b-form-input v-model="jsonDataLinguaggioScritto.letturaErba" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataLinguaggioScritto.letturaErbaPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">2. Biglia</label>
                                <b-form-input v-model="jsonDataLinguaggioScritto.letturaBiglia" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataLinguaggioScritto.letturaBigliaPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">3. Maschio</label>
                                <b-form-input v-model="jsonDataLinguaggioScritto.letturaMaschio" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataLinguaggioScritto.letturaMaschioPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">4. Sciopero</label>
                                <b-form-input v-model="jsonDataLinguaggioScritto.letturaSciopero" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataLinguaggioScritto.letturaScioperoPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">5. Camper</label>
                                <b-form-input v-model="jsonDataLinguaggioScritto.letturaCamper" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataLinguaggioScritto.letturaCamperPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">6. Formazione</label>
                                <b-form-input v-model="jsonDataLinguaggioScritto.letturaFormazione" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataLinguaggioScritto.letturaFormazionePunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">7. Stendibiancheria</label>
                                <b-form-input v-model="jsonDataLinguaggioScritto.letturaStendibiancheria" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataLinguaggioScritto.letturaStendibiancheriaPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">8. Tu hai il mio libro</label>
                                <b-form-input v-model="jsonDataLinguaggioScritto.letturaTuHaiMioLibro" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataLinguaggioScritto.letturaTuHaiMioLibroPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">9. Lei cercava di essere felice</label>
                                <b-form-input v-model="jsonDataLinguaggioScritto.letturaLeiCercavaEssereFelice" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataLinguaggioScritto.letturaLeiCercavaEssereFelicePunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">10. Dove te lo devo lasciare?</label>
                                <b-form-input v-model="jsonDataLinguaggioScritto.letturaDoveTeDevoLasciare" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataLinguaggioScritto.letturaDoveTeDevoLasciarePunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row class="justify-content-end">
                    <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                        <label class="sa-label-data">Totale parte I</label>
                        <b-form-input :value="jsonDataLinguaggioScritto.letturaPartePrimaPunteggio" type="number" readonly tabindex="-1" class="font-weight-bold"></b-form-input>
                    </b-col>
                </b-row>
            </b-card>
            <b-card class="sa-card sa-card-border mb-3" header="Parte seconda: Dettato per composizione" header-tag="header">
                <b-row>
                    <b-col class="aat-field" cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data" for="aat-dettato-composizione-prova-preliminare-uno">Prova preliminare * — Eseguibile / Non eseguibile</label>
                        <b-form-radio-group id="aat-dettato-composizione-prova-preliminare-uno" v-model="jsonDataLinguaggioScritto.dettatoComposizioneProvaPreliminareUno" name="aat-dettato-composizione-prova-preliminare-uno" class="d-flex flex-wrap aat-options" :options="eseguibileOptions" :disabled="isReadOnly"></b-form-radio-group>
                        <span v-if="jsonDataLinguaggioScritto.dettatoComposizioneProvaPreliminareUno != null && !eseguibileOptions.includes(jsonDataLinguaggioScritto.dettatoComposizioneProvaPreliminareUno)" class="sa-label-data-secondary">{{ jsonDataLinguaggioScritto.dettatoComposizioneProvaPreliminareUno }}</span>
                    </b-col>
                    <b-col class="aat-field" cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data" for="aat-dettato-composizione-prova-preliminare-sei">Prova preliminare ** — Eseguibile / Non eseguibile</label>
                        <b-form-radio-group id="aat-dettato-composizione-prova-preliminare-sei" v-model="jsonDataLinguaggioScritto.dettatoComposizioneProvaPreliminareSei" name="aat-dettato-composizione-prova-preliminare-sei" class="d-flex flex-wrap aat-options" :options="eseguibileOptions" :disabled="isReadOnly"></b-form-radio-group>
                        <span v-if="jsonDataLinguaggioScritto.dettatoComposizioneProvaPreliminareSei != null && !eseguibileOptions.includes(jsonDataLinguaggioScritto.dettatoComposizioneProvaPreliminareSei)" class="sa-label-data-secondary">{{ jsonDataLinguaggioScritto.dettatoComposizioneProvaPreliminareSei }}</span>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">1. * O/R/M/A</label>
                                <b-form-input v-model="jsonDataLinguaggioScritto.dettatoComposizioneOrma" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataLinguaggioScritto.dettatoComposizioneOrmaPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">2. S/O/G/L/I/A</label>
                                <b-form-input v-model="jsonDataLinguaggioScritto.dettatoComposizioneSoglia" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataLinguaggioScritto.dettatoComposizioneSogliaPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">3. M/U/S/C/H/I/O</label>
                                <b-form-input v-model="jsonDataLinguaggioScritto.dettatoComposizioneMuschio" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataLinguaggioScritto.dettatoComposizioneMuschioPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">4. S/C/I/A/B/O/L/A</label>
                                <b-form-input v-model="jsonDataLinguaggioScritto.dettatoComposizioneSciabola" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataLinguaggioScritto.dettatoComposizioneSciabolaPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">5. P/O/S/T/E/R</label>
                                <b-form-input v-model="jsonDataLinguaggioScritto.dettatoComposizionePoster" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataLinguaggioScritto.dettatoComposizionePosterPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">6. ** Salva/taggio</label>
                                <b-form-input v-model="jsonDataLinguaggioScritto.dettatoComposizioneSalvataggio" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataLinguaggioScritto.dettatoComposizioneSalvataggioPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">7. Porta/asciuga/mano</label>
                                <b-form-input v-model="jsonDataLinguaggioScritto.dettatoComposizionePortasciugamano" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataLinguaggioScritto.dettatoComposizionePortasciugamanoPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">8. Lui/vuole/la/sua/mano</label>
                                <b-form-input v-model="jsonDataLinguaggioScritto.dettatoComposizioneLuiVuoleSuaMano" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataLinguaggioScritto.dettatoComposizioneLuiVuoleSuaManoPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">9. Lei/crede/di/essere/salva</label>
                                <b-form-input v-model="jsonDataLinguaggioScritto.dettatoComposizioneLeiCredeEssereSalva" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataLinguaggioScritto.dettatoComposizioneLeiCredeEssereSalvaPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">10. Perché/me/la/vuole/portare</label>
                                <b-form-input v-model="jsonDataLinguaggioScritto.dettatoComposizionePercheMeVuolePortare" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataLinguaggioScritto.dettatoComposizionePercheMeVuolePortarePunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row class="justify-content-end">
                    <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                        <label class="sa-label-data">Totale parte II</label>
                        <b-form-input :value="jsonDataLinguaggioScritto.dettatoComposizioneParteSecondaPunteggio" type="number" readonly tabindex="-1" class="font-weight-bold"></b-form-input>
                    </b-col>
                </b-row>
            </b-card>
            <b-card class="sa-card sa-card-border mb-3" header="Parte terza: Dettato con scrittura a mano" header-tag="header">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">1. Onda</label>
                                <b-form-input v-model="jsonDataLinguaggioScritto.dettatoManoOnda" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataLinguaggioScritto.dettatoManoOndaPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">2. Tiglio</label>
                                <b-form-input v-model="jsonDataLinguaggioScritto.dettatoManoTiglio" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataLinguaggioScritto.dettatoManoTiglioPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">3. Vischio</label>
                                <b-form-input v-model="jsonDataLinguaggioScritto.dettatoManoVischio" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataLinguaggioScritto.dettatoManoVischioPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">4. Scivolo</label>
                                <b-form-input v-model="jsonDataLinguaggioScritto.dettatoManoScivolo" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataLinguaggioScritto.dettatoManoScivoloPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">5. Corner</label>
                                <b-form-input v-model="jsonDataLinguaggioScritto.dettatoManoCorner" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataLinguaggioScritto.dettatoManoCornerPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">6. Fondazione</label>
                                <b-form-input v-model="jsonDataLinguaggioScritto.dettatoManoFondazione" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataLinguaggioScritto.dettatoManoFondazionePunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">7. Motociclista</label>
                                <b-form-input v-model="jsonDataLinguaggioScritto.dettatoManoMotociclista" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataLinguaggioScritto.dettatoManoMotociclistaPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">8. Voi avete la vostra parte</label>
                                <b-form-input v-model="jsonDataLinguaggioScritto.dettatoManoVoiAveteVostraParte" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataLinguaggioScritto.dettatoManoVoiAveteVostraPartePunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">9. Egli pensava di essere malato</label>
                                <b-form-input v-model="jsonDataLinguaggioScritto.dettatoManoEgliPensavaEssereMalato" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataLinguaggioScritto.dettatoManoEgliPensavaEssereMalatoPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">10. Perché/me/la/vuole/portare</label>
                                <b-form-input v-model="jsonDataLinguaggioScritto.dettatoManoPercheMeVuolePortare" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataLinguaggioScritto.dettatoManoPercheMeVuolePortarePunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row class="justify-content-end">
                    <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                        <label class="sa-label-data">Totale parte III</label>
                        <b-form-input :value="jsonDataLinguaggioScritto.dettatoManoParteTerzaPunteggio" type="number" readonly tabindex="-1" class="font-weight-bold"></b-form-input>
                    </b-col>
                </b-row>
            </b-card>
            <b-row>
                <b-col class="aat-field" cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Punteggio totale (parti I–III)</label>
                    <b-form-input :value="jsonDataLinguaggioScritto.linguaggioScrittoPunteggioTotale" type="number" readonly tabindex="-1" class="font-weight-bold"></b-form-input>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>
export default {
    name: "RsaSchedaAachenerAphasieTestLinguaggioScrittoEditComponent",
    props: {
        jsonDataLinguaggioScritto: { type: Object, required: true },
        isReadOnly: { type: Boolean, default: false },
    },
    data() {
        return {
            punteggioOptions: [
                { value: null, text: "- Seleziona valore -", disabled: true },
                0, 1, 2, 3,
            ],
            eseguibileOptions: ["Eseguibile", "Non eseguibile"],
        };
    },
};
</script>

<style scoped>
.aat-field {
    margin-bottom: 1rem;
}
.aat-field .sa-label-data {
    align-items: flex-end;
    display: flex;
    min-height: 2.5rem;
}
.aat-textarea {
    height: 7rem;
    resize: none;
}
.aat-options {
    gap: 0.75rem;
}
</style>
